import {
  createParentConnectRequestMockHandler,
  getParentConnectOverviewMockHandler,
  getParentConnectSlotsMockHandler,
} from '@/features/parent-connect-booking/api';

export const parentConnectBookingHandlers = [
  getParentConnectOverviewMockHandler,
  getParentConnectSlotsMockHandler,
  createParentConnectRequestMockHandler,
];
